export const AUTH_ID_TOKEN = 'auth_id_token';
export const AUTH_TOKEN = 'auth_token';
